// @core/api/endpoints/payment/get_payment_route.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetPaymentRouteResponse,
} from '../../../types/payment';

const BASE_PATH = '/payment';

/**
 * Get payment route by ID
 * Retrieves payment route by the specified identifier.
 */
export async function GetPaymentRoute(
  id: string,
  options?: RequestOptions
): Promise<GetPaymentRouteResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/payment-routes/:id`;
  requestPath = requestPath.replace(':id', encodeURIComponent(id));
  const requestOptions = options;
  return client.get<GetPaymentRouteResponse>(requestPath, { ...requestOptions });
}
